module.exports = __webpack_public_path__ + "img/hayamichi.4f1e5775.png";